import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Page from 'components/layout/Page';
import Faqs from 'components/marketingSite/shared/Faqs';
import Feature from 'components/marketingSite/shared/Feature';
import HtmlTrans from 'components/shared/HtmlTrans';
import { useI18n } from 'hooks/useI18n';
import { OwnTeam } from 'interfaces/own-team.interface';
import { Tech } from 'model';
import { Trans } from 'next-i18next';
import BringYourOwnTeamCommitment from './BringYourOwnTeamCommitment';
import {
  StyledContainer,
  StyledWrapper
} from './BringYourOwnTeamComponent.styled';
import BringYourOwnTeamHero from './BringYourOwnTeamHero';
import BringYourOwnTeamHow from './BringYourOwnTeamHow';
import BringYourOwnTeamTeams from './BringYourOwnTeamTeams';

type BringYourOwnTeamComponentProps = { techs: Tech[]; teams: OwnTeam[] };

const BringYourOwnTeamComponent: React.FC<BringYourOwnTeamComponentProps> = ({
  techs,
  teams
}) => {
  //const { locale } = useRouter();
  const { t } = useI18n('bring-your-own-team');

  const desc = (
    <Trans
      ns={'bring-your-own-team'}
      i18nKey={'faqs.desc'}
      components={{
        mail: <a href="mailto:team@getmanfred.com"></a>
      }}
    ></Trans>
  );

  const faqs = [
    {
      question: t('faqs.faq1.question'),
      answer: t('faqs.faq1.answer')
    },
    {
      question: t('faqs.faq2.question'),
      answer: t('faqs.faq2.answer')
    },
    {
      question: t('faqs.faq3.question'),
      answer: t('faqs.faq3.answer')
    },
    {
      question: t('faqs.faq4.question'),
      answer: (
        <HtmlTrans ns={'bring-your-own-team'} i18nKey={'faqs.faq4.answer'} />
      ),
      renderComponent: true
    }
  ];

  return (
    <Page hasScrollTop topBarTransparent>
      <StyledContainer>
        <BringYourOwnTeamHero teams={teams} />
        <Feature
          title={t('feature.title')}
          text={t('feature.desc')}
          action={t('feature.CTA')}
          actionHref="https://getmanfred.typeform.com/to/AEJG1scy"
          image="bring-your-own-team-feature.svg"
          btnVariant="primary"
          actionIcon={<FontAwesomeIcon icon={faCheckCircle} />}
        />
        <StyledWrapper>
          <BringYourOwnTeamTeams techs={techs} teams={teams} />
          <BringYourOwnTeamHow />
          <BringYourOwnTeamCommitment />
        </StyledWrapper>
        <Faqs faqs={faqs} title={t('faqs.title')} desc={desc} />
      </StyledContainer>
    </Page>
  );
};

export default BringYourOwnTeamComponent;
